export const gossips = [
  {
    id: 'a1',
    title: '顶流男星深夜密会神秘女子 停车场内停留约两小时',
    type: 'gossip',
    category: 'feiwen',
    categoryName: '明星绯闻',
    tags: ['顶流', '密会', '绯闻', '深夜'],
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20night%20scene%20of%20a%20sleek%20black%20luxury%20car%20parked%20in%20a%20dim%20underground%20parking%20garage%2C%20moody%20dark%20tones%20with%20soft%20red%20neon%20reflections%2C%20dramatic%20editorial%20photography%20aesthetic%2C%20mysterious%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=800&height=600&seq=cover-a1&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=Stylized%20silhouettes%20of%20two%20figures%20standing%20apart%20near%20an%20elevator%20in%20a%20dark%20modern%20parking%20garage%2C%20dramatic%20low%20key%20lighting%20with%20red%20accents%2C%20cinematic%20mystery%20mood%2C%20editorial%20photography%20aesthetic%2C%20high%20detail&width=900&height=600&seq=gal-a1-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Abstract%20night%20city%20skyline%20seen%20through%20rain%20covered%20glass%20in%20dark%20moody%20tones%20with%20soft%20red%20neon%20glow%2C%20artistic%20blur%2C%20cinematic%20urban%20atmosphere%2C%20high%20detail%2C%20dramatic%20composition&width=900&height=600&seq=gal-a1-2&orientation=landscape',
    ],
    excerpt:
      '有网友爆料称，某顶流男星深夜现身城东某高端公寓，与一名神秘女子在停车场内交谈约两小时后才分别离开，全程低调遮掩。',
    content: [
      '据多位网友爆料，10月12日深夜，被粉丝称为"顶流"的男演员沈亦辰被发现出现在城东一处高端公寓的地下停车场。爆料者表示，当晚约22点，一辆深色商务车驶入停车场，车上人员全程佩戴帽子与口罩，行动十分谨慎。',
      '爆料人称，车辆停稳后，沈亦辰与一名身份不明的女子先后下车，两人在车旁交谈，期间多次环顾四周。整个停留过程约持续两小时，之后二人先后离开，并未同车而行。',
      '有细心的网友根据停车场布局与周边建筑特征，比对出该公寓为城东知名的高端住宅区，出入管理严格，向来是不少艺人选择居住的区域，因此在场的"神秘女子"身份也引发大量猜测。',
      '截至发稿，沈亦辰所属工作室尚未就该事件作出任何回应。多位圈内经纪人向本站表示，艺人在非工作时间的行程属于个人隐私，外界不宜过度解读。',
      '不过，也有粉丝对爆料内容提出质疑，认为照片中的男子身形与沈亦辰存在明显差异，且时间线存在矛盾，怀疑相关内容系拼接或旧图重用。目前相关话题仍在社交平台持续发酵。',
      '本站在此提醒，网络爆料真伪难辨，涉及个人隐私的内容请广大网友理性看待，切勿在未获得证实的情况下传播，以免对相关人员造成不必要的困扰。',
    ],
    author: '爆料观察员',
    source: '圈内线人',
    publishTime: '2026-10-12T21:30:00',
    views: 128600,
    likes: 5420,
    isHot: true,
    starId: 's1',
  },
  {
    id: 'a2',
    title: '当红小花新剧片场耍大牌？导演当场摔剧本离席',
    type: 'gossip',
    category: 'yingshi',
    categoryName: '影视内幕',
    tags: ['耍大牌', '片场', '新剧', '导演'],
    cover:
      'https://readdy.ai/api/search-image?query=Dramatic%20film%20set%20scene%20with%20a%20director%20chair%2C%20film%20lights%20and%20boom%20microphone%20in%20dark%20moody%20tones%20with%20red%20accent%20lighting%2C%20cinematic%20behind%20the%20scenes%20atmosphere%2C%20editorial%20photography%20aesthetic%2C%20high%20detail&width=800&height=600&seq=cover-a2&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20discarded%20film%20script%20on%20a%20dark%20studio%20floor%20with%20dramatic%20side%20lighting%20and%20warm%20amber%20tones%2C%20cinematic%20mood%2C%20shallow%20depth%20of%20field%2C%20high%20detail%2C%20editorial%20aesthetic&width=900&height=600&seq=gal-a2-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Empty%20film%20studio%20with%20professional%20lighting%20rigs%20and%20camera%20equipment%20in%20dark%20cinematic%20tones%20with%20soft%20red%20glow%2C%20moody%20behind%20the%20scenes%20atmosphere%2C%20high%20detail&width=900&height=600&seq=gal-a2-2&orientation=landscape',
    ],
    excerpt:
      '有剧组工作人员爆料，某当红小花在新剧拍摄期间多次迟到并临时修改台词，导致进度受阻，导演一度当场摔剧本离席。',
    content: [
      '近日，一名自称参与某古装新剧拍摄的工作人员在社交平台发帖爆料，称剧组内部出现严重矛盾，矛头直指该剧女主角、当红小花林晚晴。',
      '爆料称，拍摄进入中段后，林晚晴多次迟到，最长的一次让全组在片场等待超过两个小时，同时她还频繁要求临时修改台词与走位，导致已搭好的场景需要反复调整，拍摄进度受到明显影响。',
      '该工作人员称，矛盾在一次夜戏拍摄中达到顶点，导演在沟通未果后当场摔下剧本离席，现场气氛一度十分紧张，部分工作人员甚至提前收工。',
      '消息传出后，迅速登上多个社交平台的热搜榜单。支持林晚晴的粉丝认为，爆料缺乏实锤，且剧组工作强度本就极大，不应将所有问题归咎于演员个人。',
      '也有不少网友持观望态度，指出该剧开机以来官方物料极少，杀青时间一再推迟，认为爆料并非空穴来风，呼吁片方尽早给出说明。',
      '截至发稿，林晚晴方面与剧组均未作出正式回应。本站将持续关注事件后续进展，也提醒网友理性讨论，避免传播未经证实的内容。',
    ],
    author: '剧透小分队',
    source: '剧组工作人员',
    publishTime: '2026-10-11T18:05:00',
    views: 97500,
    likes: 3980,
    isHot: true,
    starId: 's2',
  },
  {
    id: 'a3',
    title: '综艺剪辑风波升级 参赛选手发文控诉节目组恶意剪辑',
    type: 'gossip',
    category: 'zongyi',
    categoryName: '综艺爆料',
    tags: ['综艺', '剪辑', '争议', '选手'],
    cover:
      'https://readdy.ai/api/search-image?query=Modern%20television%20studio%20with%20colorful%20stage%20lights%20in%20dark%20moody%20tone%20with%20vibrant%20red%20and%20amber%20accents%2C%20cinematic%20broadcast%20atmosphere%2C%20editorial%20photography%20aesthetic%2C%20high%20detail&width=800&height=600&seq=cover-a3&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=Close%20up%20of%20professional%20video%20editing%20timeline%20on%20a%20dark%20monitor%20screen%2C%20glowing%20red%20and%20amber%20waveforms%2C%20cinematic%20tech%20mood%2C%20shallow%20depth%20of%20field%2C%20high%20detail%2C%20editorial%20aesthetic&width=900&height=600&seq=gal-a3-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Empty%20variety%20show%20stage%20with%20spotlights%20and%20judges%20desks%20in%20dark%20moody%20tones%20with%20red%20accent%20lighting%2C%20dramatic%20cinematic%20atmosphere%2C%20high%20detail&width=900&height=600&seq=gal-a3-2&orientation=landscape',
    ],
    excerpt:
      '一档热门竞演综艺被曝剪辑争议，多位参赛选手先后发文，称节目组通过剪辑引导舆论，放大了彼此之间的矛盾冲突。',
    content: [
      '近期一档热度极高的竞演类综艺陷入剪辑风波。多位参赛选手在社交平台先后发文，称节目播出内容与实际录制情况存在出入，节目组通过选择性剪辑刻意放大了选手之间的矛盾。',
      '其中一名选手在长文中表示，录制现场的气氛其实相当融洽，但成片却只保留了少量争执片段，配以紧张的背景音乐，最终呈现出"剑拔弩张"的观感，令自己和家人承受了巨大的舆论压力。',
      '另一名选手则贴出部分现场花絮，佐证自己的说法，表示并非要为落败鸣不平，而是希望观众能看到完整的自己，而不是被剪辑塑造出的"人设"。',
      '事件发酵后，节目组通过官方账号发布回应，强调所有内容均基于真实录制素材，剪辑遵循节目节奏与播出规范，并否认存在"恶意引导"的情况。',
      '不过，这一回应并未平息争议。不少观众指出，近年的竞演综艺普遍存在"放大冲突博话题"的倾向，呼吁行业加强对真人秀剪辑的规范，尊重参与者的真实形象。',
      '截至目前，相关话题阅读量仍在持续攀升，多位业内人士也加入讨论。事件最终走向如何，仍有待观察。',
    ],
    author: '综艺前线',
    source: '节目观众爆料',
    publishTime: '2026-10-10T12:20:00',
    views: 76300,
    likes: 2870,
    isHot: true,
    starId: 's7',
  },
  {
    id: 'a4',
    title: '豪门婚变实锤？女方深夜搬离亿元豪宅',
    type: 'gossip',
    category: 'feiwen',
    categoryName: '明星绯闻',
    tags: ['豪门', '婚变', '豪宅', '实锤'],
    cover:
      'https://readdy.ai/api/search-image?query=Luxurious%20modern%20villa%20exterior%20at%20night%20with%20dark%20moody%20tones%20and%20soft%20warm%20accent%20lighting%2C%20gated%20mansion%20driveway%2C%20cinematic%20editorial%20photography%20aesthetic%2C%20high%20detail%2C%20mysterious%20atmosphere&width=800&height=600&seq=cover-a4&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=Moving%20boxes%20and%20luggage%20stacked%20near%20the%20entrance%20of%20a%20luxury%20home%20at%20night%20in%20dark%20moody%20tones%20with%20warm%20porch%20light%2C%20cinematic%20storytelling%20aesthetic%2C%20high%20detail&width=900&height=600&seq=gal-a4-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Elegant%20empty%20bedroom%20interior%20of%20a%20luxury%20mansion%20at%20dusk%20with%20dark%20moody%20tones%20and%20soft%20warm%20lighting%2C%20cinematic%20melancholy%20mood%2C%20high%20detail%2C%20editorial%20aesthetic&width=900&height=600&seq=gal-a4-2&orientation=landscape',
    ],
    excerpt:
      '有邻居爆料称，某明星夫妻位于城郊的亿元豪宅深夜出现搬家公司车辆，女方在助理陪同下带走多箱行李，外界猜测二人婚变传闻或已成真。',
    content: [
      '近日，有自称住在某高端别墅区的网友爆料，称10月9日深夜，某明星夫妻的住所外出现了搬家公司车辆，多名工作人员将带有个人物品标识的纸箱与行李箱搬上车。',
      '爆料者称，搬迁过程中，女方在助理与安保人员的陪同下出现，戴着帽子与口罩，全程未作停留便乘车离开，而男方当日并未现身。整个过程持续约一个半小时。',
      '该明星夫妻此前已多次被传婚变，双方在社交平台的互动一度归零，各自的公开行程也鲜有同框，因而此番深夜搬离的画面被部分网友视为"实锤"。',
      '也有理性的网友指出，搬家原因可能涉及房屋维护、工作安排等多种情况，仅凭搬运动作难以断定婚姻状况，呼吁外界不要过度揣测。',
      '截至发稿，双方工作室均未就此事公开回应，其各自的社交账号也保持着一贯的沉默。有媒体尝试联系其经纪团队，暂未获得回复。',
      '值得一提的是，两人名下共同持有的多处商业投资近年来陆续发生变更，相关工商信息显示部分股权已完成转移，这也让外界对二人关系的走向更加好奇。',
    ],
    author: '豪门观察',
    source: '小区邻居',
    publishTime: '2026-10-09T23:40:00',
    views: 88900,
    likes: 3510,
    isHot: true,
    starId: 's3',
  },
  {
    id: 'a5',
    title: '音乐节假唱风波再升级 现场原声被扒出对比',
    type: 'gossip',
    category: 'wangluo',
    categoryName: '网络传闻',
    tags: ['假唱', '音乐节', '原声', '对比'],
    cover:
      'https://readdy.ai/api/search-image?query=Large%20outdoor%20music%20festival%20stage%20at%20night%20with%20crowd%20silhouettes%20and%20bright%20red%20stage%20lighting%20in%20dark%20moody%20tones%2C%20cinematic%20concert%20atmosphere%2C%20editorial%20photography%20aesthetic%2C%20high%20detail&width=800&height=600&seq=cover-a5&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20stage%20microphone%20on%20a%20stand%20under%20dramatic%20red%20spotlight%20in%20dark%20tones%2C%20cinematic%20concert%20mood%2C%20shallow%20depth%20of%20field%2C%20high%20detail%2C%20editorial%20aesthetic&width=900&height=600&seq=gal-a5-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Audio%20waveform%20visualization%20glowing%20on%20a%20dark%20screen%20with%20red%20and%20amber%20tones%2C%20cinematic%20tech%20aesthetic%2C%20abstract%20dramatic%20lighting%2C%20high%20detail&width=900&height=600&seq=gal-a5-2&orientation=landscape',
    ],
    excerpt:
      '某音乐节演出后，一段据称是现场原声的音频在网络流传，网友通过对比指出多位歌手疑似假唱，相关话题迅速登上热搜。',
    content: [
      '刚刚落幕的一场大型户外音乐节，因一段"现场原声"音频的流出而陷入争议。有网友将现场收音与直播版本进行对比，指出部分歌手在现场的声音与播出效果存在明显差异。',
      '爆料者称，通过将现场观众拍摄的视频与官方直播画面同步播放，可以听出个别歌手在高音段落的呼吸与口型对不上，怀疑存在"半开麦"乃至完全假唱的情况。',
      '相关对比视频在社交平台快速传播，短时间内播放量突破百万。不少网友表示，观众花钱买票看现场，期待的是真实的演唱，而非一场"对口型表演"。',
      '也有声音为歌手辩护，认为音乐节现场环境复杂，收音设备、天气、体力等因素都会影响演出效果，仅凭网友自制的对比视频难以得出定论。',
      '面对争议，音乐节主办方与涉事歌手团队暂未作出正式说明。有业内人士分析，随着现场直播与观众拍摄的普及，假唱越来越难以隐藏，行业也正面临更高的透明化要求。',
      '本站提醒，网络流传的音频与视频存在被后期处理的可能性，判断是否假唱应基于权威渠道的信息，切勿人云亦云。',
    ],
    author: '乐现场',
    source: '现场观众',
    publishTime: '2026-10-08T15:10:00',
    views: 64100,
    likes: 2210,
    isHot: false,
    starId: 's4',
  },
  {
    id: 'a6',
    title: '影帝消失半年后低调现身 疑因合约纠纷遭雪藏',
    type: 'gossip',
    category: 'mingxing',
    categoryName: '明星动态',
    tags: ['影帝', '雪藏', '合约', '复出'],
    cover:
      'https://readdy.ai/api/search-image?query=Lone%20figure%20in%20a%20long%20coat%20walking%20through%20an%20empty%20rainy%20city%20street%20at%20dusk%20in%20dark%20moody%20tones%20with%20soft%20amber%20streetlights%2C%20cinematic%20melancholy%20aesthetic%2C%20high%20detail%2C%20editorial%20photography&width=800&height=600&seq=cover-a6&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=Classic%20film%20camera%20resting%20on%20a%20shelf%20in%20a%20dim%20room%20with%20dark%20moody%20tones%20and%20a%20single%20warm%20light%20beam%2C%20cinematic%20nostalgic%20mood%2C%20high%20detail%2C%20editorial%20aesthetic&width=900&height=600&seq=gal-a6-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Stack%20of%20unsigned%20film%20contracts%20and%20documents%20on%20a%20dark%20wooden%20desk%20with%20dramatic%20side%20lighting%20and%20amber%20tones%2C%20cinematic%20mood%2C%20high%20detail&width=900&height=600&seq=gal-a6-2&orientation=landscape',
    ],
    excerpt:
      '有媒体拍到低调影帝江砚在消失近半年后独自现身机场，身形消瘦引发关注，知情人士称其或与经纪公司存在合约纠纷。',
    content: [
      '向来低调的影帝江砚，已近半年未出现在公众视野。近日，有媒体在机场拍到他独自推着行李现身，头戴棒球帽，身形较此前明显消瘦，状态引发外界广泛关注。',
      '有知情人士向本站透露，江砚与所属经纪公司的合约纠纷或已持续数月，双方的续约谈判陷入僵局，期间他推掉了多部电影邀约，这也是他长时间"消失"的原因之一。',
      '爆料还称，由于合约条款对艺人接戏渠道有所限制，江砚在纠纷厘清前难以自由挑选项目，团队运作也因此近乎停滞，令不少业内人士感到惋惜。',
      '江砚的粉丝则纷纷在社交平台留言表达支持，希望他能早日解决争议、回归荧幕。也有影迷翻出他过往的经典作品，感慨"好演员不该被合约耽误"。',
      '截至发稿，江砚本人及其经纪公司均未就合约问题作出回应。多位律师在接受采访时表示，艺人与经纪公司之间的合约纠纷往往涉及利益分配、竞业限制等多项条款，解决需要时间。',
      '无论真相如何，这位实力派演员的动向都牵动着无数影迷的心。本站将持续关注事件的后续发展。',
    ],
    author: '星途观察',
    source: '知情人士',
    publishTime: '2026-10-07T09:25:00',
    views: 71200,
    likes: 4100,
    isHot: false,
    starId: 's6',
  },
  {
    id: 'a7',
    title: '女团成员退团内幕曝光 与公司矛盾疑公开化',
    type: 'gossip',
    category: 'mingxing',
    categoryName: '明星动态',
    tags: ['女团', '退团', '内幕', '单飞'],
    cover:
      'https://readdy.ai/api/search-image?query=Empty%20concert%20stage%20with%20a%20single%20spotlight%20and%20scattered%20glow%20sticks%20in%20dark%20moody%20tones%20with%20pink%20and%20red%20accents%2C%20cinematic%20farewell%20atmosphere%2C%20editorial%20photography%20aesthetic%2C%20high%20detail&width=800&height=600&seq=cover-a7&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=Group%20of%20empty%20microphone%20stands%20on%20a%20dark%20stage%20with%20one%20stand%20pulled%20away%2C%20dramatic%20red%20and%20amber%20lighting%2C%20cinematic%20symbolic%20mood%2C%20high%20detail%2C%20editorial%20aesthetic&width=900&height=600&seq=gal-a7-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Backstage%20dressing%20room%20with%20mirror%20bulbs%20and%20abandoned%20costumes%20in%20dark%20moody%20tones%20with%20warm%20accent%20light%2C%20cinematic%20melancholy%20mood%2C%20high%20detail&width=900&height=600&seq=gal-a7-2&orientation=landscape',
    ],
    excerpt:
      '人气女团成员顾清欢宣布退团后，一则内部沟通记录在网络流传，显示其与经纪公司在资源分配与个人发展上存在长期分歧。',
    content: [
      '人气女团成员顾清欢上月突然宣布退团，消息令粉丝措手不及。近日，一份据称来自其与前经纪公司之间的沟通记录在网络流传，让退团原因逐渐浮出水面。',
      '记录显示，顾清欢方面曾就个人资源分配、音乐风格主导权以及长约条款提出异议，认为公司在团体活动与个人发展之间的安排存在明显失衡，多次沟通未果。',
      '知情人士称，双方矛盾的焦点在于一份即将到期的合约，公司希望续签长期合作，而顾清欢倾向于独立发展，谈判一度陷入僵持。',
      '退团后，顾清欢在个人账号发布了简短声明，感谢团队与粉丝，表示将以独立音乐人的身份继续创作。声明未提及合约争议，但字里行间流露出对过往阶段的告别之意。',
      '对于网络流传的沟通记录，其前经纪公司尚未作出正式回应。部分业内人士指出，偶像团体成员与公司之间的合约纠纷并不罕见，如何平衡团体利益与个人发展，是行业长期存在的难题。',
      '粉丝群体对此反应不一，有人理解她的选择，也有人为团队就此"缺角"而惋惜。顾清欢的下一步动向，成为外界关注的焦点。',
    ],
    author: '偶像档案馆',
    source: '内部人士',
    publishTime: '2026-10-06T20:00:00',
    views: 55800,
    likes: 2450,
    isHot: false,
    starId: 's5',
  },
  {
    id: 'a8',
    title: '夫妻档分居传闻发酵 双方工作室回应前后矛盾',
    type: 'gossip',
    category: 'feiwen',
    categoryName: '明星绯闻',
    tags: ['分居', '回应', '夫妻', '矛盾'],
    cover:
      'https://readdy.ai/api/search-image?query=Two%20separate%20coffee%20cups%20on%20opposite%20ends%20of%20a%20long%20dark%20marble%20table%20with%20moody%20lighting%20and%20amber%20accents%2C%20cinematic%20symbolic%20storytelling%20aesthetic%2C%20high%20detail%2C%20editorial%20photography&width=800&height=600&seq=cover-a8&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=Two%20apartment%20key%20sets%20lying%20apart%20on%20a%20dark%20surface%20under%20dramatic%20side%20lighting%20with%20warm%20amber%20tones%2C%20cinematic%20symbolic%20mood%2C%20high%20detail%2C%20editorial%20aesthetic&width=900&height=600&seq=gal-a8-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Dim%20elegant%20living%20room%20at%20night%20with%20a%20single%20lit%20lamp%20in%20dark%20moody%20tones%20and%20warm%20accents%2C%20cinematic%20lonely%20atmosphere%2C%20high%20detail&width=900&height=600&seq=gal-a8-2&orientation=landscape',
    ],
    excerpt:
      '某明星夫妻分居传闻持续发酵，其双方工作室先后发布声明，却因措辞与时间点不一致，被网友质疑回应自相矛盾。',
    content: [
      '近日，一对常年被誉为"模范夫妻"的明星夫妻被曝已分居数月，消息最早的来源是两人共同出席活动的次数骤减，以及社交平台上长期零交流。',
      '随着传闻发酵，男方工作室率先发声明，称夫妻二人感情稳定，相关报道纯属恶意揣测，并保留追究造谣者法律责任的权利。',
      '然而不到半天，女方工作室也发布了声明，措辞却更为谨慎，仅表示"以艺人官方发布为准"，并未直接否认分居传闻，两份声明的差异立刻引发网友热议。',
      '有网友梳理时间线指出，男方声明发布后，女方曾在私人账号短暂点赞过一条暗示"各自安好"的评论，虽随后取消，但已被截图留存，进一步加深了外界的猜测。',
      '也有理性的声音提醒，明星夫妻的工作安排本就容易造成聚少离多，长期不同框不能直接等同于感情破裂，媒体与网友应给予当事人足够的空间。',
      '截至发稿，双方均未就两份声明的差异作出进一步解释。事件真相尚不明朗，本站将持续跟进。',
    ],
    author: '情感观察室',
    source: '多方爆料',
    publishTime: '2026-10-05T11:15:00',
    views: 69300,
    likes: 3020,
    isHot: false,
    starId: 's3',
  },
  {
    id: 'a9',
    title: '古装大剧临时换角 男主演被指与制片方闹掰',
    type: 'gossip',
    category: 'yingshi',
    categoryName: '影视内幕',
    tags: ['换角', '古装剧', '制片方', '纠纷'],
    cover:
      'https://readdy.ai/api/search-image?query=Ornate%20traditional%20Chinese%20palace%20corridor%20at%20dusk%20with%20dark%20moody%20tones%20and%20warm%20lantern%20light%2C%20cinematic%20epic%20historical%20drama%20aesthetic%2C%20high%20detail%2C%20editorial%20photography&width=800&height=600&seq=cover-a9&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20costume%20draped%20over%20a%20wooden%20rack%20in%20a%20dim%20studio%20with%20dark%20moody%20tones%20and%20warm%20amber%20light%2C%20cinematic%20behind%20the%20scenes%20mood%2C%20high%20detail&width=900&height=600&seq=gal-a9-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Empty%20historical%20drama%20set%20with%20red%20pillars%20and%20lanterns%20at%20night%20in%20dark%20moody%20tones%20with%20warm%20accents%2C%20cinematic%20atmospheric%20mood%2C%20high%20detail&width=900&height=600&seq=gal-a9-2&orientation=landscape',
    ],
    excerpt:
      '一部备受期待的古装大剧被曝在开机后临时更换男主演，知情人称原定演员因片酬与番位问题与制片方产生分歧，谈判最终破裂。',
    content: [
      '一部投资规模不小的古装大剧近日被曝在开机后临时更换男主演，原定加盟的青年演员在官宣数日后悄然退出，引发大量猜测。',
      '有知情人向本站透露，双方矛盾的焦点集中在片酬与番位安排上。原定演员方面希望在宣传物料中明确其"领衔主演"地位，而制片方出于多方考量未能完全满足，谈判因此陷入僵局。',
      '爆料称，在多次协商无果后，制片方选择启用备选演员，并于拍摄计划临近时完成替换，虽然避免了整体进度的大幅延后，但前期的部分场景需要重新拍摄。',
      '对于换角传闻，剧方目前仅发布了简短的阵容更新公告，未对原因作出说明。新加入的演员则通过工作室发布了定妆照，表示将全力以赴诠释角色。',
      '业内人士分析，古装大剧的番位之争由来已久，演员与制片方在利益分配上的博弈时有发生，临时换角既可能影响剧集品质，也会给演员本人的口碑带来波动。',
      '目前该剧已恢复拍摄，事件是否会进一步发酵，仍有待观察。本站将持续关注。',
    ],
    author: '影视内外',
    source: '剧组知情人',
    publishTime: '2026-10-04T16:45:00',
    views: 52700,
    likes: 1880,
    isHot: false,
    starId: 's8',
  },
  {
    id: 'a10',
    title: '网红情侣突然宣布分手 双方粉丝互撕不断',
    type: 'gossip',
    category: 'wangluo',
    categoryName: '网络传闻',
    tags: ['分手', '网红', '粉丝', '争议'],
    cover:
      'https://readdy.ai/api/search-image?query=Cracked%20heart%20shaped%20neon%20sign%20glowing%20in%20a%20dark%20moody%20room%20with%20soft%20red%20light%2C%20atmospheric%20cinematic%20aesthetic%2C%20editorial%20photography%2C%20high%20detail&width=800&height=600&seq=cover-a10&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=Two%20smartphones%20lying%20face%20down%20on%20a%20dark%20table%20with%20dramatic%20side%20lighting%20and%20red%20accents%2C%20cinematic%20modern%20symbolic%20mood%2C%20high%20detail%2C%20editorial%20aesthetic&width=900&height=600&seq=gal-a10-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Broken%20porcelain%20photo%20frame%20on%20a%20dark%20surface%20with%20moody%20low%20key%20lighting%20and%20warm%20amber%20tones%2C%20cinematic%20melancholy%20aesthetic%2C%20high%20detail&width=900&height=600&seq=gal-a10-2&orientation=landscape',
    ],
    excerpt:
      '一对拥有千万粉丝的网红情侣突发长文宣布分手，双方在字里行间互相暗示矛盾，导致各自粉丝在评论区展开激烈互撕。',
    content: [
      '近日，一对在短视频平台拥有千万粉丝的网红情侣先后发布长文，宣布结束数年的恋情，消息迅速冲上多个平台的热度榜单。',
      '男方的声明中表示，两人因长期异地与事业规划差异选择和平分开，并感谢对方多年来的陪伴。随后，女方的长文语气明显不同，提到"有些付出从未被看见"，被网友解读为暗指自身在感情中受到的委屈。',
      '两份声明释放出的信号并不一致，迅速点燃了粉丝的情绪。男方粉丝认为女方"阴阳怪气"，女方粉丝则指责男方"避重就轻"，双方在评论区展开激烈争论，相关话题一度失控。',
      '有网友翻出两人此前的合体直播片段，指出早在数月前双方的互动就明显减少，猜测分手或许早有征兆。也有人呼吁粉丝理性，认为感情是当事人的私事，外人无从评判。',
      '目前，双方均未就粉丝之间的争论作出回应，此前共同经营的账号也已暂停更新。多位内容创作者指出，网红情侣的"情感内容"本身自带流量，但也让私人关系承受了额外的压力。',
      '无论如何，曾经被无数人羡慕的一段感情就此画上句号，留给外界的除了唏嘘，也有对流量与情感边界的思考。',
    ],
    author: '网络显微镜',
    source: '平台爆料',
    publishTime: '2026-10-03T19:30:00',
    views: 47600,
    likes: 1640,
    isHot: false,
    starId: 's4',
  },
];